import { render, staticRenderFns } from "./EmployerDetails.vue?vue&type=template&id=71fabc2a&"
import script from "./EmployerDetails.vue?vue&type=script&lang=js&"
export * from "./EmployerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports